<script setup></script>
<template>
  <div class="loading-spin">
    <div class="text-center p-3">
      <div class="spinner-border text-primary" role="status"></div>
      <p>Đang tải... Vui lòng chờ !</p>
    </div>
  </div>
</template>

<style scoped lang="scss">
@import '~scssAsset/components/common/loading.scss';
</style>
